var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.752 19.336C15.008 19.336 17.36 17.068 18.704 14.744L15.288 13.092C14.504 14.632 12.824 15.808 10.752 15.808C7.504 15.808 5.04 13.204 5.04 9.676C5.04 6.148 7.504 3.544 10.752 3.544C12.824 3.544 14.504 4.748 15.288 6.26L18.704 4.58C17.388 2.256 15.008 0.0159991 10.752 0.0159991C5.292 0.0159991 0.952 3.936 0.952 9.676C0.952 15.416 5.292 19.336 10.752 19.336Z",
    fill: "#4274F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClever);
export default __webpack_public_path__ + "static/media/clever.eeb6ecb6.svg";
export { ForwardRef as ReactComponent };